import React from "react";

import { Wrapper } from "./styles";

const GridBoardList = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default GridBoardList;
